import { render, staticRenderFns } from "./ServicesReservations.vue?vue&type=template&id=28ffc375&"
import script from "./ServicesReservations.vue?vue&type=script&lang=js&"
export * from "./ServicesReservations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports